<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">contact_phone</v-icon> {{ $util.isRol('ADMIN') ? 'Listado de casos' : 'Listado de casos por entidad' }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
        >
          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="verCaso(items.item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <span>Ver detalles de caso</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="conversar(items.item)">
                  <v-icon>chat</v-icon>
                </v-btn>
                <span>{{$t('operadores.ingresar')}}</span>
              </v-tooltip>
            </td>
            <td>{{ items.item.tipo }}</td>
            <td>
              {{ `${items.item['persona.nombres'] || ''}${items.item['persona.primer_apellido'] ? ' '+items.item['persona.primer_apellido'] : ''}${items.item['persona.segundo_apellido'] ? ' '+items.item['persona.segundo_apellido'] : ''}` }}
            </td>
            <td>{{ items.item['persona.nro_documento'] }}</td>
            <td>{{ items.item['descripcion'].substring(0, 40) }}</td>
            <!-- <td>{{ items.item['persona.telefono'] }}</td>
            <td>{{ items.item['persona.movil'] }}</td> -->
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ items.item['punto_atencion.identificador'] }}</span>
                </template>
                <span>{{ items.item['punto_atencion.entidad.nombre'] }}</span>
              </v-tooltip>
            </td>
            <td>
              <v-icon small :color="direccionColor(items.item)">{{direccionContenido(items.item)}}</v-icon>
              <v-tooltip bottom v-if="items.item['ultimoMensaje.tipo_contenido'] === 'texto'">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ `${items.item['ultimoMensaje.contenido'].substring(0, 40)} ${items.item['ultimoMensaje.contenido'].length > 40 ? '...' : ''}` }}</span>
                </template>
                <span>{{ items.item['ultimoMensaje.contenido'] }}</span>
              </v-tooltip>
              <span v-if="items.item['ultimoMensaje.tipo_contenido'] !== 'texto'">{{ formatoContenido(items.item) }}</span>
            </td>
            <td>{{ items.item._updated_at ? formato(items.item._updated_at) : formato(items.item._created_at) }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'ACTIVO' || items.item.estado == 'PENDIENTE'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'CANCELADO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'CERRADO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <v-dialog :key="dialogKey" v-model="dialog" max-width="1000">
      <v-card>
        <v-card-title class="headline m-0">
          <v-flex xs9>
            <v-icon>history</v-icon> {{$t('operadores.caso.resumen')}}
          </v-flex>
          <v-flex xs2 text-md-right>
            <v-chip label color="success" text-color="white" v-if="caso_seleccionado.estado == 'PENDIENTE'">
              {{ caso_seleccionado.estado }}
            </v-chip>
            <v-chip label color="success" text-color="white" v-if="caso_seleccionado.estado == 'ACTIVO'">
              {{ caso_seleccionado.estado }}
            </v-chip>
            <v-chip label color="warning" text-color="white" v-if="caso_seleccionado.estado == 'CERRADO'">
              {{ caso_seleccionado.estado }}
            </v-chip>
            <v-chip label color="danger" text-color="white" v-if="caso_seleccionado.estado == 'CANCELADO'">
              {{ caso_seleccionado.estado }}
            </v-chip>
          </v-flex>
          <v-flex xs1 text-md-right>
            <v-btn small flat icon @click.native="dialog = false">
              <v-icon class="red--text">cancel</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <caso-resumen :key="caso_seleccionado.id" :caso="caso_seleccionado"></caso-resumen>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="red"
            @click.native="dialog = false">
            <v-icon>close</v-icon> {{$t('common.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :key="dialogInfoKey" v-model="dialogInfo" max-width="700">
      <v-card>
        <v-card-title class="headline m-0">
          <v-flex xs9>
            <v-icon>remove_red_eye</v-icon> Información adicional de caso
          </v-flex>
          <v-flex xs2 text-md-right>
            <v-chip label color="success" text-color="white" v-if="caso.estado == 'ACTIVO' || caso.estado == 'PENDIENTE'">
              {{ caso.estado }}
            </v-chip>
            <v-chip label color="danger" text-color="white" v-if="caso.estado == 'CANCELADO'">
              {{ caso.estado }}
            </v-chip>
            <v-chip label color="warning" text-color="white" v-if="caso.estado == 'CERRADO'">
              {{ caso.estado }}
            </v-chip>
          </v-flex>
          <v-flex xs1 text-md-right>
            <v-btn small flat icon @click.native="dialogInfo = false">
              <v-icon class="red--text">cancel</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text outlined elevation="2">
          <v-layout wrap>
            <v-flex xs12>
              <strong>Descripción del caso</strong>
              <v-card flat>
                <v-card-text>
                  {{ caso.descripcion }}
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 v-if="caso['tramite.nombre_tramite']">
              <strong>Trámite</strong>
              <p>{{ caso['tramite.nombre_tramite'] }}</p>
            </v-flex>
            <v-flex xs12>
              <strong>Fecha de apertura</strong>
              <v-chip :ripple="false">{{ formato(caso._created_at) }}</v-chip>
            </v-flex>
            <v-flex xs12 v-if="caso._updated_at && caso.estado!=='CERRADO'">
              <strong>Última actividad</strong>
              <v-chip :ripple="false">{{ formato(caso._updated_at) }}</v-chip>
            </v-flex>
            <v-flex xs12 v-if="caso.estado === 'CERRADO'">
              <strong>Fecha de cierre</strong>
              <v-chip :ripple="false">{{ formato(caso._updated_at) }}</v-chip>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <strong>Datos del solicitante</strong>
            </v-flex>
            <v-flex xs12 v-if="caso.id_persona">
              Nombre:
              <v-chip :ripple="false">{{ `${caso['persona.nombres']} ${caso['persona.primer_apellido']} ${caso['persona.segundo_apellido'] || ''}` }}</v-chip>
            </v-flex>
            <v-flex xs6 v-if="caso['persona.telefono']">
              Teléfono:
              <v-chip :ripple="false">{{ caso['persona.telefono'] }}</v-chip>
            </v-flex>
            <v-flex xs6 v-if="caso['persona.movil']">
              Celular:
              <v-chip :ripple="false">{{ caso['persona.movil'] }}</v-chip>
            </v-flex>
            <v-flex xs12>
              Fuentes asociadas:
              <v-chip v-for="canal in caso.canales" :key="canal.usuario">
                Identificador: {{ `${canal.usuario}` }} Tipo: {{ `${canal.clasificacion}` }} 
              </v-chip>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="red"
            @click.native="dialogInfo = false">
            <v-icon>close</v-icon> {{ $t('common.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';
import usuario from '../usuario/mixins/usuario';
import CasoResumen from '../operadores/CasoResumen';
import moment from 'moment';
// import puntoAtencion from './mixins/puntoAtencion';

export default {
  mixins: [ crud, validate, token, logDatos, usuario ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.casos = [];
    // this.getEntidades(0);
  },
  mounted () {},
  data () {
    return {
      caso_seleccionado: {id: 0},
      casos: [],
      caso: {},
      logDatos: null,
      successAlert: false,
      graphql: false, // Definiendo el CRUD con Graphql
      url: 'system/admin-casos',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        // { text: this.$t('common.active'), sortable: false },
        { text: this.$t('caso.crud.tipo'), value: 'tipo' },
        { text: this.$t('caso.crud.nombre_completo'), value: 'persona.nombres' },
        { text: this.$t('caso.crud.nro_documento'), value: 'persona.nro_documento' },
        { text: this.$t('caso.crud.descripcion'), value: 'descripcion' },
        // { text: this.$t('caso.crud.telefono'), value: 'persona.telefono' },
        // { text: this.$t('caso.crud.movil'), value: 'persona.movil' },
        { text: this.$t('caso.crud.identificador'), value: 'punto_atencion.identificador' },
        { text: this.$t('caso.crud.ultimo_mensaje'), value: 'ultimoMensaje.contenido' },
        { text: this.$t('caso.crud.ultima_actualizacion'), value: '_updated_at' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      form: {},
      dataGraphql: `
        id
        tipo
        estado
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [
        {
          field: 'nombre_completo',
          label: this.$t('caso.crud.nombre_completo'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'nro_documento',
          label: this.$t('caso.crud.nro_documento'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'identificador',
          label: this.$t('caso.crud.identificador'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'descripcion',
          label: this.$t('caso.crud.descripcion'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'estado',
          label: this.$t('common.status'),
          type: 'select',
          typeG: 'EstadoEntidad',
          items: [
            { value: 'TODOS', text: 'TODOS' },
            { value: 'ACTIVO', text: 'ACTIVO' },
            { value: 'CERRADO', text: 'CERRADO' },
            { value: 'CANCELADO', text: 'CANCELADO' },
            { value: 'PENDIENTE', text: 'PENDIENTE' }
          ]
        }
      ],
      idEntidad: null,
      valid: true,
      dialogKey: 'dialogo-caso',
      dialog: false,
      dialogInfoKey: 'dialogo-info-caso',
      dialogInfo: false
    };
  },
  methods: {
    verCaso (data) {
      this.caso = Object.assign({}, data);
      this.dialogInfoKey = 'dialogCasoKey' + Math.random().toString(36).substr(2, 5);
      this.dialogInfo = true;
    },
    formatoContenido (item) {
      let contenidoParams = item['ultimoMensaje.contenido'].split('/');
      let i = contenidoParams.length;
      if (i > 0) {
        return `${item['ultimoMensaje.tipo_contenido']} ${contenidoParams[i - 1]}`;
      } else {
        return `${item['ultimoMensaje.tipo_contenido']} ${item['ultimoMensaje.contenido']}`;
      }
    },
    direccionContenido (item) {
      let icono = 'priority_high';
      switch (item[`ultimoMensaje.direccion`]) {
        case 'ENTRADA':
          icono = 'arrow_back';
          break;
        case 'SALIDA':
          icono = 'arrow_forward';
          break;
      }
      return icono;
    },
    direccionColor (item) {
      let icono = 'default';
      switch (item[`ultimoMensaje.direccion`]) {
        case 'ENTRADA':
          icono = 'red';
          break;
        case 'SALIDA':
          icono = 'green';
          break;
      }
      return icono;
    },
    formato (fecha) {
      moment.locale('es');
      return moment(fecha).format('LLLL');
    },
    imagenCanal (clasificacion) {
      let imagen = 'call.png';
      switch (clasificacion) {
        case 'whatsapp':
          imagen = 'wp.png';
          break;
        case 'facebook':
          imagen = 'fb.png';
          break;
        case 'twitter':
          imagen = 'tw.png';
          break;
        case 'correo':
          imagen = 'mail.png';
          break;
      }
      return require('@/assets/images/' + imagen);
    },
    conversar (caso) {
      this.ingresar(caso);
    },
    ingresar (caso) {
      this.caso_seleccionado = caso;
      this.dialog = true;
    }
  },
  components: {
    CrudTable,
    LogDatos,
    CasoResumen
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/administrador_casos/AdministradorCaso.vue